
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/transportbil/fiat-ducato",
      function () {
        return require("private-next-pages/wheels/transportbil/fiat-ducato.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/transportbil/fiat-ducato"])
      });
    }
  